import React from 'react'
import {useParams} from 'react-router-dom'

import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import {HTTPError, HTTPNotFound} from '@salesforce/pwa-kit-react-sdk/ssr/universal/errors'
import {useProduct, usePages} from '@salesforce/commerce-sdk-react'
import {Page} from '@salesforce/commerce-sdk-react/components'

import ProductContent from './partials/product-content'
import {PAGEDESIGNER_TO_COMPONENT} from '../../page-designer/pd-configs'
import {extractProductId} from '../../utils/url'

const ProductDetail = () => {
    const {slug} = useParams()
    const productId = extractProductId(slug)

    /*********** Product based on url parameter **************/
    const {data: product} = useProduct({
        parameters: {
            id: productId,
            allImages: false
        }
    })

    /******* Page designer Page based on product primary category ****/
    const {data: pdPage, error} = usePages({
        parameters: {
            aspectTypeId: 'pdp',
            categoryId: (product && product.primaryCategoryId) || 'root'
        }
    })

    if (error) {
        let ErrorClass = error.response?.status === 404 ? HTTPNotFound : HTTPError
        throw new ErrorClass(error.response?.statusText)
    }

    const isPageDesignerPage = pdPage?.data?.length > 0
    if (isPageDesignerPage) {
        return (
            <Box className="sf-pd-product-detail-page">
                <Page page={pdPage.data[0]} components={PAGEDESIGNER_TO_COMPONENT} />
            </Box>
        )
    } else {
        return <ProductContent />
    }
}

export default ProductDetail
